var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPrepaidCardIcon = function SvgPrepaidCardIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 21,
    rx: 3.5,
    stroke: "#E1E1E1",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0H14V3.02746C13.2656 3.10865 12.5844 3.36658 12 3.75777C11.4156 3.36658 10.7344 3.10865 10 3.02746V0ZM5.02746 8H0V12H7.17144L7.5939 11.5775C6.20504 10.9272 5.20302 9.58814 5.02746 8ZM10 14.8283V22H14V14.5461L12.0603 12.768L10 14.8283ZM17.1421 12H32V8H18.9725C18.8046 9.51923 17.8804 10.8105 16.5847 11.489L17.1421 12Z",
    fill: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9699 8.61597L18.6757 14.763L17.3243 16.2373L12.0301 11.3842L7.20712 16.2072L5.79291 14.793L11.9699 8.61597Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 5.05051C11.3647 4.40223 10.4793 4 9.49994 4C7.56694 4 5.99994 5.567 5.99994 7.5C5.99994 9.433 7.56694 11 9.49994 11C10.4793 11 11.3647 10.5978 11.9999 9.94949C12.6352 10.5978 13.5206 11 14.4999 11C16.4329 11 17.9999 9.433 17.9999 7.5C17.9999 5.567 16.4329 4 14.4999 4C13.5206 4 12.6352 4.40223 11.9999 5.05051ZM7.99994 7.5C7.99994 6.67157 8.67151 6 9.49994 6C10.3284 6 10.9999 6.67157 10.9999 7.5V9H9.49994C8.67151 9 7.99994 8.32843 7.99994 7.5ZM14.4999 9C15.3284 9 15.9999 8.32843 15.9999 7.5C15.9999 6.67157 15.3284 6 14.4999 6C13.6715 6 12.9999 6.67157 12.9999 7.5V9H14.4999Z",
    fill: "#AEAEAE"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPrepaidCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "prepaid-card-icon.f79a183e7c89d35ccaf3c00c4ec9f7c5.svg";